import * as THREE from 'three';
import { FontLoader } from 'three/examples/jsm/loaders/FontLoader.js';
import { TextGeometry } from 'three/examples/jsm/geometries/TextGeometry.js';
import { EffectComposer } from 'three/examples/jsm/postprocessing/EffectComposer.js';
import { RenderPass } from 'three/examples/jsm/postprocessing/RenderPass.js';
import { BokehPass } from 'three/examples/jsm/postprocessing/BokehPass.js';
import { OutputPass } from 'three/examples/jsm/postprocessing/OutputPass.js';
import { AfterimagePass } from 'three/examples/jsm/postprocessing/AfterimagePass.js';


export class WebGPURenderer extends THREE.WebGLRenderer {
   constructor() {
      super();
      this.context = null;
   }
   
   async init() {
      const adapter = await navigator.gpu.requestAdapter();
      const device = await adapter.requestDevice();
      this.context = this.getContext();
      this.context.gpu = device;
   }
}

export default class Tunnel {
   constructor() {
      const t = this;

      function isPortrait(){ return window.innerWidth < window.innerHeight; }

      var stageWidth = window.innerWidth;
      var stageHeight = window.innerHeight;

      var cameraTarget = new THREE.Vector3(0, -50, 0);
      var camera = this.camera = new THREE.OrthographicCamera(stageWidth / - 2, stageWidth / 2, stageHeight / 2, stageHeight / - 2, 1, 10000);
      // var camera = this.camera = new THREE.PerspectiveCamera(90, stageWidth / stageHeight, 160, 1000);
      camera.position.set(0, 400, 0);
      camera.lookAt(cameraTarget);

      var scene = this.scene = new THREE.Scene();
      scene.background = new THREE.Color(0x000000);

      scene.fog = new THREE.FogExp2(0x000000, 0.002);

      var ambientLight = this.ambientLight = new THREE.AmbientLight(0xffffff, 0.5);
      scene.add(ambientLight);

      var group = this.group = new THREE.Object3D();
      scene.add(group);

      // add half sphere to group
      let radius = window.innerHeight*.666;
      var geometry = new THREE.SphereGeometry(radius, 64, 8, 0, Math.PI * 2, 0, Math.PI / 2);
      var material = new THREE.MeshBasicMaterial({
         color: 0xffffff,
         wireframe: true,
         // side: THREE.BackSide
      });
      var sphere = this.sphere = new THREE.Mesh(geometry, material);
      // center the sphere
      sphere.rotation.x = Math.PI / 2 * 2 * 2;
      sphere.position.set(0, -radius/2, 0);
      // sphere.position.set(0, 0, 0);
      group.add(sphere);

      var afterimagePass;

      let clock = new THREE.Clock();
      let delta = 0;
      let interval = 1 / 60;

      t.allowRender = true;

      this.update = function update() {
         requestAnimationFrame(t.update);
         delta += clock.getDelta();
         if (delta  > interval) {
            if(t.allowRender) {
               render();
            }
            
            delta = delta % interval;
         }
      }

      // const renderer = this.renderer = new WebGPURenderer({
      //    antialias: true,
      //    alpha: false
      // });
      // renderer.init();

      var renderer = new THREE.WebGLRenderer({
         antialias: false,
         alpha: false
      });
      renderer.setPixelRatio(window.devicePixelRatio);
      renderer.outputColorSpace = THREE.SRGBColorSpace;
      renderer.setSize(stageWidth, stageHeight);

      document.body.appendChild(renderer.domElement);
      renderer.domElement.setAttribute('id', "tunnel");

      // post fx
      var composer = new EffectComposer(renderer);
      var renderPass = new RenderPass(scene, camera);
      composer.addPass(renderPass);
      composer.setSize(stageWidth, stageHeight);

      window.onresize = function() {
         renderer.setSize( window.innerWidth, window.innerHeight );
         composer.setSize( window.innerWidth, window.innerHeight );
         renderer.setPixelRatio(window.devicePixelRatio);
         stageWidth = window.innerWidth;
         stageHeight = window.innerHeight;
         camera.left = stageWidth / - 2;
         camera.right = stageWidth / 2;
         camera.top = stageHeight / 2;
         camera.bottom = stageHeight / - 2;
         camera.updateProjectionMatrix();

         global.isTouch = 'ontouchstart' in window || navigator.maxTouchPoints;
      };

      const postprocessing = {};

      function initPostprocessing() {

         const renderPass = new RenderPass( scene, camera );

         // const bokehPass = new BokehPass( scene, camera, {
         //    focus: 10.0,
         //    aperture: 0.025,
         //    maxblur: 0.001
         // } );

         const outputPass = new OutputPass();

         const composer = new EffectComposer( renderer );

         composer.addPass( renderPass );
         // composer.addPass( bokehPass );

         afterimagePass = new AfterimagePass(0.55);
         composer.addPass( afterimagePass );
         
         composer.addPass( outputPass );
         
         postprocessing.composer = composer;
         postprocessing.afterimage = afterimagePass;
         // postprocessing.bokeh = bokehPass;

      }

      initPostprocessing();

      var rotSpeed = 0.005;
      window.onmousemove = function(e) {
         if(!isTouch) {
            postprocessing.afterimage.uniforms.damp.value = (e.clientY / window.innerHeight) * 0.35 + 0.5;
            rotSpeed = (e.clientX / window.innerWidth) * 0.02 - 0.01;
         } else {
            postprocessing.afterimage.uniforms.damp.value = 0.55;
         }
      }

      const isHome = $('body').hasClass('home');
      const isError = $('body').hasClass('error');
      
      var rotation = 0.0;

      function render() {

         camera.rotation.z = rotation;
         rotation += 0.009;
         camera.lookAt(cameraTarget);

         // group.rotation.x += 0.005; // Rotate the tunnel slightly
         group.rotation.y += rotSpeed; // Rotate the tunnel slightly
         
         // renderer.render(scene, camera);
         // composer.render();
         postprocessing.composer.render( 0.1 );

      }

      t.update();

      setTimeout(function(){
         document.getElementById('tunnel').style.opacity = 1;
      }, 50);

   }
}
